import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest.js';

const BASE            = `${config.API_URL}KPIDashboardActivity`;
const BASE_KPI_CONFIG = `${config.API_URL}KPIDashboardKpiConfig`;
const BASE_KPI_DATA   = `${config.API_URL}KPIDashboardKpiData`;

export const searchActivities = ({ search, technology, isActive, page = 1, pageSize = 50 }) =>
	AxiosRequest({ method: 'GET', url: BASE, params: { search, technology, isActive, page, pageSize } });

export const getActivityDetail = (id) =>
	AxiosRequest({ method: 'GET', url: `${BASE}/${id}` });

export const getActivityFilterOptions = (id, filters = {}) =>
	AxiosRequest({ method: 'POST', url: `${BASE}/${id}/filter-options`, data: { activityId: id, ...filters } });

export const getActivityPhases = (id) =>
	AxiosRequest({ method: 'GET', url: `${BASE}/${id}/phases` });

export const getKpiConfig = () =>
	AxiosRequest({ method: 'GET', url: BASE_KPI_CONFIG });

export const getKpiConfigByTech = (tech) =>
	AxiosRequest({ method: 'GET', url: `${BASE_KPI_CONFIG}/${tech}` });

export const getKpiBatch = (charts) =>
	AxiosRequest({ method: 'POST', url: `${BASE_KPI_DATA}/batch`, data: { charts } });